module.exports = __webpack_public_path__ + "static/media/cardiff_2.2ba0b8b8.jpg";